import { render, staticRenderFns } from "./ProductStock.vue?vue&type=template&id=65dee732&scoped=true&name=product-stock&"
import script from "./ProductStock.vue?vue&type=script&lang=js&"
export * from "./ProductStock.vue?vue&type=script&lang=js&"
import style0 from "./ProductStock.vue?vue&type=style&index=0&id=65dee732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dee732",
  null
  
)

/* custom blocks */
import block0 from "./ProductStock.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports